// src/components/common/ProductListSchema.jsx
import { Helmet } from "react-helmet-async";

export default function ProductListSchema({ products, pageUrl }) {
  if (!products || products.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: products.map((p, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Product",
        name: p.name,
        image: p.image_url || p.image,
        url: `${pageUrl}/${p.slug || p.id}`,
        offers: {
          "@type": "Offer",
          price: p.new_price || p.price,
          priceCurrency: "INR",
          availability: "https://schema.org/InStock",
        },
      },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}